import { LicenseType } from '@celum/authentication';
import { IconConfiguration } from '@celum/common-components/icon';
import { CelumPropertiesProvider } from '@celum/core/configuration';
import { hasValue } from '@celum/core/util';

import { ServiceTabItemConfiguration } from '../../model/service-tab-item/service-tab-item-configuration';

export const HOME_SERVICE_NAME = 'Home';
const HOME_SERVICE_ICON = 'home-colored';

export const CONTENT_HUB_SERVICE_NAME = 'Content';
const CONTENT_HUB_SERVICE_ICON = 'content-hub-main-colored';

export const WORKROOMS_SERVICE_NAME = 'Work';
const WORKROOMS_SERVICE_ICON = 'workroom-colored';

export const LIBRARIES_SERVICE_NAME = 'Libraries';
const LIBRARIES_SERVICE_ICON = 'libraries-colored';

export const EXPERIENCE_SERVICE_NAME = 'Experience';
const EXPERIENCE_SERVICE_ICON = 'experience-colored';

export const FORMATS_SERVICE_NAME = 'Formats';

export const ORGANISATION_DETAILS_SERVICE_NAME = 'OrganisationDetails';
const ORGANISATION_DETAILS_ICON = 'settings-outlined-colored';

export type TabItemConfiguration = Omit<ServiceTabItemConfiguration, 'active' | 'onClick'>;

export const HOME_TAB_ITEM: TabItemConfiguration = {
  text: HOME_SERVICE_NAME,
  iconConfiguration: new IconConfiguration(HOME_SERVICE_ICON),
  subServices: null,
  dataComponentId: 'home',
  applicationUrl: CelumPropertiesProvider.properties.systemBar.home?.httpBaseAddress
};

export function isHomeTabItem(tabItem: TabItemConfiguration): boolean {
  return tabItem?.text === HOME_SERVICE_NAME;
}

export const CONTENT_TAB_ITEM: TabItemConfiguration = {
  text: CONTENT_HUB_SERVICE_NAME,
  iconConfiguration: new IconConfiguration(CONTENT_HUB_SERVICE_ICON).withColor('#fff'),
  subServices: null,
  dataComponentId: 'dashboard',
  licenseType: LicenseType.CONTENT_HUB,
  fallbackUrlPerLanguage: CelumPropertiesProvider.properties.systemBar.contentHubFallbackUrlPerLanguage
};

export function isContentTabItem(tabItem: TabItemConfiguration): boolean {
  return tabItem?.text === CONTENT_HUB_SERVICE_NAME;
}

export const WORKROOMS_TAB_ITEM: TabItemConfiguration = {
  text: WORKROOMS_SERVICE_NAME,
  iconConfiguration: new IconConfiguration(WORKROOMS_SERVICE_ICON).withColor('#fff'),
  subServices: null,
  dataComponentId: 'workflow',
  licenseType: LicenseType.WORK,
  applicationUrl: CelumPropertiesProvider.properties.systemBar.workAppUrl
};

export function isWorkroomTabItem(tabItem: TabItemConfiguration): boolean {
  return tabItem?.text === WORKROOMS_SERVICE_NAME;
}

export const LIBRARIES_TAB_ITEM: TabItemConfiguration = {
  text: LIBRARIES_SERVICE_NAME,
  iconConfiguration: new IconConfiguration(LIBRARIES_SERVICE_ICON).withColor('#fff'),
  subServices: null,
  dataComponentId: 'libraries',
  licenseType: LicenseType.LIBRARIES,
  applicationUrl: CelumPropertiesProvider.properties.systemBar.librariesAppUrl,
  fallbackUrlPerLanguage: CelumPropertiesProvider.properties.systemBar.librariesFallbackUrlPerLanguage
};

export function isLibrariesTabItem(tabItem: TabItemConfiguration): boolean {
  return tabItem?.text === LIBRARIES_SERVICE_NAME;
}

export const EXPERIENCE_TAB_ITEM: TabItemConfiguration = {
  text: EXPERIENCE_SERVICE_NAME,
  iconConfiguration: new IconConfiguration(EXPERIENCE_SERVICE_ICON).withColor('#fff'),
  subServices: null,
  dataComponentId: 'portals',
  licenseType: LicenseType.EXPERIENCE,
  applicationUrl: CelumPropertiesProvider.properties.systemBar.experienceAppUrl,
  fallbackUrlPerLanguage: CelumPropertiesProvider.properties.systemBar.experienceFallbackUrlPerLanguage
};

export function isExperienceTabItem(tabItem: TabItemConfiguration): boolean {
  return tabItem?.text === EXPERIENCE_SERVICE_NAME;
}

/**
 * Deprecated, should be removed with https://celum.atlassian.net/browse/CH-9973
 */
export const FORMATS_TAB_ITEM: TabItemConfiguration = {
  text: FORMATS_SERVICE_NAME,
  iconConfiguration: undefined,
  subServices: null,
  dataComponentId: 'formats',
  licenseType: LicenseType.EXPERIENCE,
  applicationUrl: CelumPropertiesProvider.properties.systemBar.formats?.httpBaseAddress
};

/**
 * Deprecated, should be removed with https://celum.atlassian.net/browse/CH-9973
 */
export function isFormatsTabItem(tabItem: TabItemConfiguration): boolean {
  return tabItem?.text === FORMATS_SERVICE_NAME;
}

const saccUrl = hasValue(CelumPropertiesProvider.properties.saccUrl)
  ? CelumPropertiesProvider.properties.saccUrl
  : CelumPropertiesProvider.properties.authentication.saccUrl.replace('/api', '');
export const ORGANISATION_DETAILS_TAB_ITEM: TabItemConfiguration = {
  text: undefined,
  iconConfiguration: new IconConfiguration(ORGANISATION_DETAILS_ICON).withIconSize(34),
  subServices: null,
  dataComponentId: ORGANISATION_DETAILS_SERVICE_NAME,
  licenseType: LicenseType.NO_LICENSE,
  applicationUrl: saccUrl
};

export function isOrganisationDetailsTabItem(tabItem: TabItemConfiguration): boolean {
  return tabItem?.dataComponentId === ORGANISATION_DETAILS_SERVICE_NAME;
}
